import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_CANDIDATES = gql`
    query OnboardingCandidates($candidatesRequest: CandidatesRequestDto) {
        onboardingCandidates(candidatesRequest: $candidatesRequest) {
            candidates {
                uuid
                email
                firstname
                lastname
                phoneNumber
                city
                countryCode
                language
                step
                resetComment
                unreadChatMessagesCount
                uploadedDocumentsCount
            }
            hasNext
        }
    }
`;

const useOnboardingCandidates = (sliceNumber, searchString, sortOrder, step) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_CANDIDATES, {
        variables: {
            candidatesRequest: {
                sliceNumber,
                searchString: searchString || null,
                sortOrder,
                step: step || null,
            },
        },
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingCandidates,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingCandidates;
